import { HIDDEN_ROOTS } from '../../config/constants';
import { endpointWrapper } from 'utils/api/meta.api';

const shapePlanResonse = (plan) => {
    plan.plans.sort();
    return {
        ...plan,
        id: plan.plans.join('||'),
        name: plan.plans.toLocaleString(),
        industry: Array.from(
            new Set([...plan.industries, 'audience', ...HIDDEN_ROOTS]),
        ),
    };
};

export const getUserPlanNonAdmin = () =>
    endpointWrapper({ domain: 'user/plan', method: 'GET' }).then(
        shapePlanResonse,
    );

const adminPlansOverrideKey = 'spate-app-admin-plans';

export const setUserPlan = ({ plans }) => {
    try {
        localStorage.setItem(adminPlansOverrideKey, JSON.stringify(plans));
    } finally {
        return endpointWrapper({ domain: 'user/plan', data: { plans } }).then(
            shapePlanResonse,
        );
    }
};

export const getUserPlan = () => {
    let plans;
    try {
        plans = JSON.parse(localStorage.getItem(adminPlansOverrideKey));
    } finally {
        if (!(plans && plans.length)) return getUserPlanNonAdmin();
        return setUserPlan({ plans }).catch((err) => {
            if (err.status === 404) {
                try {
                    localStorage.removeItem(adminPlansOverrideKey);
                } finally {
                    return getUserPlanNonAdmin();
                }
            }
            throw err;
        });
    }
};

export const getPlans = () =>
    endpointWrapper({ domain: 'plans', method: 'GET' }).then((plans) =>
        plans.map(shapePlanResonse),
    );
